import React from 'react';
import Icon from 'components/canvas/components/icon';
import { useSelectedNodeOperations } from 'state/canvas/selected-node';
import { useTranslation } from 'i18n';
import { useLoggedUser } from 'state/user';
import useRemoveNodeFromCache from 'components/canvas/hooks/use-remove-node-from-cache';
import useCanvas from 'components/canvas/hooks/use-canvas';
import Delete from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/delete.svg';
import DeleteGold from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/delete-red.svg';
import revokeUserAccessOnSurface from 'graphql/user/mutations/revoke-user-access-on-surface';
import { toast } from 'services/toast';
import { SurfaceNodeUnion } from 'graphql/types';

export interface SurfaceNodeRevokeAccessIconProps {
  onClick?: Function;
  width?: number;
  height?: number;
  node: SurfaceNodeUnion;
}

const defaultProps = {};

function SurfaceNodeRevokeAccessIcon(props: SurfaceNodeRevokeAccessIconProps) {
  const { node } = props;
  const { t } = useTranslation();
  const [loggedUser] = useLoggedUser();
  const { clearSelectedNode } = useSelectedNodeOperations();
  const { deleteConfirmModalRef } = useCanvas();
  const removeNodeFromCache = useRemoveNodeFromCache();

  const [isSelected, setSelected] = React.useState<boolean>(false);

  const src = isSelected ? DeleteGold : Delete;

  function deleteNode() {
    if (node) {
      return revokeUserAccessOnSurface({
        input: {
          surface: node.id,
          user: loggedUser?.id,
        },
      }).then((response) => {
        if (response.isFailure) {
          return toast.error(response.getErrorMessage());
        }

        clearSelectedNode();
        removeNodeFromCache(node);

        toast.success(
          t(`Successfully deleted node and removed access for {{name}} cell`, {
            replace: { name: node?.name || '' },
          }),
        );

        return response;
      });
    }
  }

  async function showDeleteConfirmation() {
    if (node) {
      deleteConfirmModalRef.current?.setData({
        name: node.name,
        additionalText: t('By deleting cell {{name}} you will lose access.', {
          replace: { name: node.name },
        }),
        onConfirmHandler: deleteNode,
      });

      deleteConfirmModalRef.current?.show();
    }
  }

  function onClick(event) {
    event.cancleBubble = true;

    if (node) {
      showDeleteConfirmation();
    }

    props.onClick && props.onClick(event);
  }

  return (
    <Icon
      {...props}
      src={src}
      onClick={onClick}
      onMouseOver={() => setSelected(true)}
      onMouseOut={() => setSelected(false)}
    />
  );
}

SurfaceNodeRevokeAccessIcon.defaultProps = defaultProps;

export default SurfaceNodeRevokeAccessIcon;
